import { useUndoKeyboard } from "hooks/useUndoKeyboard";
import { useUndoScopeCleanup } from "hooks/useUndoScopeCleanup";

export default function AppUndoBindings() {
	useUndoKeyboard();
	useUndoScopeCleanup();
	return null;
}
